// extracted by mini-css-extract-plugin
export var label = "_fz-2";
export var slideContainer = "_fz-0";
export var slider = "_fz-1";